import { elegirCodigo, FORMATOS_1D } from './serieMatcher';

// Escalado del canvas antes de decodificar: una foto de tablet sale a ~4000px
// de lado y ZXing es más lento (y a veces falla) contra imágenes enormes.
// Función pura para poder testearla sin canvas/jsdom.
export function calcularDestino(anchoOriginal, altoOriginal, ladoMaximo) {
    const lado = Math.max(anchoOriginal, altoOriginal);
    if (lado <= ladoMaximo) return { ancho: anchoOriginal, alto: altoOriginal };
    const escala = ladoMaximo / lado;
    return {
        ancho: Math.round(anchoOriginal * escala),
        alto: Math.round(altoOriginal * escala),
    };
}

function dibujarEnCanvas(bitmap, ancho, alto) {
    const canvas = document.createElement('canvas');
    canvas.width = ancho;
    canvas.height = alto;
    canvas.getContext('2d').drawImage(bitmap, 0, 0, ancho, alto);
    return canvas;
}

/**
 * Decodifica un código de barras 1D desde una foto fija (vía <input
 * type="file" capture>). Es el camino que sí funciona en contexto inseguro,
 * porque los file inputs no dependen de `isSecureContext` como getUserMedia.
 *
 * Intenta primero con la imagen reducida (rápido) y, si falla, a resolución
 * completa (el código puede quedar demasiado pequeño al reducir).
 */
export async function decodificarImagen(file, patron) {
    const { BrowserMultiFormatReader } = await import('@zxing/browser');
    const { BarcodeFormat, DecodeHintType } = await import('@zxing/library');

    const hints = new Map([
        [DecodeHintType.TRY_HARDER, true],
        [DecodeHintType.POSSIBLE_FORMATS, FORMATOS_1D.map((f) => BarcodeFormat[f.toUpperCase()])],
    ]);
    const reader = new BrowserMultiFormatReader(hints);

    const bitmap = await createImageBitmap(file);
    try {
        const { ancho, alto } = calcularDestino(bitmap.width, bitmap.height, 1600);
        const intentos = ancho === bitmap.width ? [{ ancho, alto }] : [{ ancho, alto }, { ancho: bitmap.width, alto: bitmap.height }];

        for (const intento of intentos) {
            try {
                const canvas = dibujarEnCanvas(bitmap, intento.ancho, intento.alto);
                const resultado = reader.decodeFromCanvas(canvas);
                const elegido = elegirCodigo([resultado.getText()], patron);
                if (elegido) return elegido;
            } catch (e) {
                // Este intento no encontró código — se sigue con el siguiente
                // tamaño, o se agota la lista y se reporta fallo abajo.
            }
        }
        return null;
    } finally {
        bitmap.close?.();
    }
}
